import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingHeaderComponent } from '../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { BillingRequestService } from '@services/billing-request.service';
import { NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, MapfreButtonComponent],
  selector: 'app-billing-request',
  templateUrl: './billing-request.component.html',
  styleUrls: ['./billing-request.component.scss']
})
export class BillingRequestComponent implements OnInit, AfterViewInit {
  policy: any;
  policyType: string;
  loading: boolean;
  requestTypeList: Array<any>;
  policyTypeImg: string;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private billingRequestService: BillingRequestService,
    private navService: NavigationService
  ) { }

  setPolicyInfo(policy: any) {
    this.policyType = this.policy?.policyType
    this.policyTypeImg = this.billingRequestService.setPolicyTypeImage(this.policyType);
    this.requestTypeList = this.billingRequestService.getRequestTypeList(policy);
  }

  processRequest(request: any) {
    if (request === 'Discounts') {
      this.router.navigate(['my-insurance', this.policy?.policynumber.policyNumber, 'billing-discount']);
    }
    else if (request === 'Refunds') {
      this.router.navigate(['my-insurance', this.policy?.policynumber.policyNumber, 'refund-request']);
    }
    else {
      this.router.navigate(['my-insurance', this.policy?.policynumber.policyNumber, 'other-request']);
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
            .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.setPolicyInfo(this.policy)
          this.loading = false;
        }
      });
    });
    this.navService.saveCurrentAction(ActionType.BillingRequest);
  }
  openOtherReuestModal(): void {
    if (history?.state?.openOtherRequestModal) {
      const ele = document.getElementsByClassName('other-request-type')[0] as HTMLElement | undefined;
      ele?.click();
    }
  }
  ngAfterViewInit(): void {
    this.openOtherReuestModal();
  }
}
